module.exports = {
	getAreaNameFromUrl: (url) ->
		areas = [
			{ name: 'Admin', pattern: /\/admin\// }
			{ name: 'System admin', pattern: /\/system\// }
			{ name: 'Assessments', pattern: /assessment/ }
			{ name: 'Classroom view', pattern: /\/classrooms/ }
			{ name: 'Graphs', pattern: /graphs/ }
			{ name: 'Lesson plan', pattern: /lesson_plan/ }
			{ name: 'Progress monitor', pattern: /progress/ }
			{ name: 'Reports', pattern: /reports/ }
			{ name: 'Resources', pattern: /resources/ }
			{ name: 'Student information page', pattern: /students/ }
			{ name: 'Test scores', pattern: /test_scores/ }
			{ name: 'Video library', pattern: /video_library/ }
		]
		for area in areas
			if url.match area.pattern
				return area.name

	serializeForQueryString: (object, prefix) ->
		parameters = []
		Object.keys(object).map (property) ->
			if object.hasOwnProperty(property)
				key = if prefix then prefix + "[" + property + "]" else property
				value = object[property]

				if value != null && typeof value == "object"
					parameter = serializeForQueryString(value, key)
				else
					parameter = encodeURIComponent(key) + "=" + encodeURIComponent(value)

				parameters.push(parameter)

		return parameters.join("&")
}



// WEBPACK FOOTER //
// ./frontend/olos/js/lib/urlHelper.coffee